<div class="row">

    <div class="col-lg-12">
        <div class="card influencer-card">
            <div class="card-body" *ngIf="this.influencer">

                <div class="influencer-intro">
                    <div
                            class="card-img-top animated fadeIn influencer-image"
                            *ngIf="influencer.image"
                            [lazyLoad]="constants.imagesUrl() + '/images/600x350/' + influencer.image.type + '/' + influencer.image.name + '/'">
                    </div>

                    <div class="influencer-intro-text">
                        <h2>{{ this.influencer.influencer.name }}</h2>
                        <p class="duty">{{ this.influencer.influencer.duty }}</p>

                        <div class="social-links">
                            <button
                                    *ngIf="influencer.influencer.instagram_profile_link"
                                    (click)="openLink(influencer.influencer.instagram_profile_link)"
                                    class="btn btn-social-icon-text btn-instagram" type="button">
                                <i class="ti-instagram"></i>Instagram
                            </button>

                            <button
                                    *ngIf="influencer.influencer.facebook_profile_link"
                                    (click)="openLink(influencer.influencer.facebook_profile_link)"
                                    class="btn btn-social-icon-text btn-facebook" type="button">
                                <i class="ti-facebook"></i>Facebook
                            </button>

                            <button
                                    *ngIf="influencer.influencer.youtube_profile_link"
                                    (click)="openLink(influencer.influencer.youtube_profile_link)"
                                    class="btn btn-social-icon-text btn-youtube" type="button">
                                <i class="ti-youtube"></i>Youtube
                            </button>
                        </div>

                        <div id="text" [innerHTML]="this.influencer.influencer.description"></div>
                        <br/>

                        <button
                                *ngIf="influencerInSubscription === false"
                                class="btn btn-success btn-add-recipes"
                                (click)="buyInfluencerRecipes(this.influencer.influencer.id + '')">
                            <i class="mdi mdi-food-fork-drink"></i>
                            {{ 'dashboard_add_influencer_recipes_to_my_profile' | localise }}
                        </button>
                        <button
                                *ngIf="influencerInSubscription === true"
                                (click)="removeFromSubscriptionInfluencerRecipes(this.influencer.influencer.id + '')"
                                class="btn btn-danger btn-remove-recipes">
                            <i class="mdi mdi-block-helper"></i>
                            {{ 'dashboard_cancel_influencer_subscription' | localise }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row recipes-row">
    <div class="col-12">
        <div class="row portfolio-grid">
            <ng-container *ngFor="let recipe of recipes">

                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <figure class="recipe-figure" (click)="buyInfluencerRecipes(this.influencer.influencer.id + '')">
                        <div
                                (click)="buyInfluencerRecipes(this.influencer.influencer.id + '')"
                                class="card-img-top animated fadeIn recipe-influencer-image"
                                *ngIf="recipe.images.length > 0"
                                [lazyLoad]="constants.imagesUrl() + '/images/850x500/' + recipe.images[0].type + '/' + recipe.images[0].name + '/'">
                        </div>

                        <figcaption>
                            <h4 (click)="buyInfluencerRecipes(this.influencer.influencer.id + '')"
                                class="recipe-title-influencer">{{ recipe.recipe.title }}</h4>
                        </figcaption>
                    </figure>
                </div>

            </ng-container>
        </div>
    </div>
</div>
